module.exports = __webpack_public_path__ + "static/img/about_authority_04_zh.31ad453.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_authority_04_zh.png
// module id = R6sn
// module chunks = 34